<template>
  <div class="brandIntr">
    <div class="container">
      <div class="brandIntr-header">
        <swiper></swiper>
      </div>
      <div class="brandIntr-contens">
        <div class="item-brandIntr-contens">
          <div class="brandIntr-concept-title"><i></i>品牌理念<i></i></div>
          <div class="brandIntr-concept-content">
            <div class="item-brandIntr-concept">
              <img src="../assets/imgs/bg.png"/>
            </div>
            <div class="item-brandIntr-concept-cons">
              <div class="concept-title"></div>
              <div class="concept-words">专注为青少年儿童提供三大棋类教育，集研发、教学为一体，运用美国哈佛棋类教学体系和人工智能技术，通过棋类与国学、历史、社会等模块的融合，全面培养孩子思维能力的儿童素质教育品牌。</div>
              <div class="concept-words">旨在普及儿童棋类教育的同时，帮助提高孩子专注力、记忆力和逻辑思维、语言表达等多项综合能力。</div>
              <div class="concept-words">2018年与美国CEG教育机构达成战略合作。在推广三大棋类文化的同时,让孩子在趣味的棋类教学中提升综合素质能力，达到智慧成长、感情成长及创造性成长。</div>
            </div>
          </div>
          <div class="study-goals"><i></i>教育目标<i></i></div>
          <div class="study-goals-cons">
            <div class="item-goals-content" v-for="(item,index) in picList" :key="index">
              <img :src="item.img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '../components/swiper.vue'
export default {
  name: 'brandIntr',
  components: {
    Swiper
  },
  data () {
    return {
      picList: [
        {img: require('../assets/imgs/pic_1.png')},
        {img: require('../assets/imgs/pic_2.png')},
        {img: require('../assets/imgs/pic_3.png')},
        {img: require('../assets/imgs/pic_4.png')}
      ]
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .brandIntr{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container{
      width: 100%;
      .brandIntr-header{
        width: 100%;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .brandIntr-contens {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-brandIntr-contens {
          width: 100%;
          margin-bottom: 45px;
          .brandIntr-concept-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px, 40px, '../assets/imgs/xian.png');
          }
          .brandIntr-concept-content {
            width: 1180px;
            margin: auto;
            @include flex();
            margin-top: 35px;
            margin-bottom: 50px;
            .item-brandIntr-concept {
              width: 674px;
              margin-right: 40px;
            }
          }
          .item-brandIntr-concept-cons {
            width: 465px;
            text-align: left;
            .concept-title {
              width: 331px;
              height: 27px;
              @include bgImg(232px,270x,'../assets/imgs/yxx.png');
              margin-top: 118px;
              margin-bottom: 39px;
            }
            .concept-words {
              font-size:14px;
              font-family:Microsoft YaHei;
              font-weight:400;
              color:rgba(51,51,51,1);
              margin-bottom: 26px;
              &:last-child{
                margin-bottom: 124px;
              }
            }
          }
          .study-goals {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px, 40px, '../assets/imgs/xian.png');
          }
          .study-goals-cons {
            width: 100%;
            @include flexed();
            margin-top: 35px;
            display: flex;
            justify-content: space-between;
            .item-goals-content {
              width: 566px;
              height: 350px;
              margin-bottom: 35px;
              @include flex();
              img{
                  width: 100%;
                  height: 100%;
                }
              // .goals-cons-left{
              //   width: 271px;
              //   padding: 92px 42px;
              //   box-sizing: border-box;
              //   .title{
              //     font-size:24px;
              //     font-family:Microsoft YaHei;
              //     font-weight:bold;
              //     color:rgba(24,114,178,1);
              //     line-height:48px;
              //     margin-bottom: 31px;
              //   }
              //   .contents{
              //     font-size:14px;
              //     font-family:Microsoft YaHei;
              //     font-weight:bold;
              //     color:rgba(102,102,102,1);
              //     text-align: left;
              //   }
              // }
              // .goals-img-right {
              //   width: 295px;
              //   img{
              //     width: 295px;
              //     height: 350px;
              //   }
              // }
            }
            .content2{
              background-color: #e1f5f2;
            }
            .content3{
              background-color: #dff0fc;
            }
            .content4{
              background-color: #f9e3e3;
            }
          }
        }
      }
    }
    .brandIntr-concept-title,.study-goals{
      i{
        display: inline-block;
        width: 23px;
        height: 23px;
        margin-right: 26px;
        @include bgImg(23px,23px,'../assets/imgs/san_left.png');
      }
      i:last-of-type{
        margin-left: 26px;
        @include bgImg(23px,23px,'../assets/imgs/san_right.png');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/brandIntr.vue